import type { GuideTourStep, GuideTourStepCardSize } from '../types'
import * as S from './styles'

type GuideTourStepCardBodyProps = Readonly<{
  currentStep: GuideTourStep
  isSummaryOnly: boolean
  isTourUnavailablePage?: boolean
  unavailableMessage?: string | null
  cardSize: GuideTourStepCardSize
}>

export function GuideTourStepCardBody({
  currentStep,
  isSummaryOnly,
  isTourUnavailablePage = false,
  unavailableMessage = null,
  cardSize,
}: GuideTourStepCardBodyProps) {
  if (isTourUnavailablePage && unavailableMessage) {
    return (
      <S.Content>
        <S.Title id="guide-tour-unavailable-title" $cardSize={cardSize}>
          {unavailableMessage}
        </S.Title>
      </S.Content>
    )
  }

  return (
    <S.Content>
      {isSummaryOnly ? null : (
        <S.Title id="guide-tour-step-title" $cardSize={cardSize}>
          {currentStep.title}
        </S.Title>
      )}
      {isSummaryOnly ? null : (
        <S.Body id="guide-tour-step-body" $cardSize={cardSize}>
          {currentStep.body}
        </S.Body>
      )}
    </S.Content>
  )
}
